import { Outlet, RouteObject } from "react-router-dom";
import { lazyWithReload } from "src/shared/services/lazyWithReload/lazyWithReload";
import RouteProtector from "./RouteProtector";

const ListCompanyObligations = lazyWithReload(
  () =>
    import("src/payment/features/ListCompObligations/ListCompanyObligations"),
);
const ListSubscriptions = lazyWithReload(
  () => import("src/payment/features/ListSubscriptions/ListSubscriptions"),
);
const NewSubscription = lazyWithReload(
  () => import("src/payment/features/newSubscription/NewSubscription"),
);

const ListPayments = lazyWithReload(
  () => import("src/payment/features/ListPayments/ListPayments"),
);
const ListCertificatePayments = lazyWithReload(
  () =>
    import(
      "src/payment/features/ListCertificatePayments/ListCertificatePayments"
    ),
);

const ListFinePayments = lazyWithReload(
  () => import("src/payment/features/ListFinePayments/ListFinePayments"),
);

const DepositSuccess = lazyWithReload(
  () => import("src/deposit/features/DepositSuccess/DepositSuccess"),
);

export const paymentPaths: RouteObject = {
  path: "/payment",
  element: <Outlet />,
  children: [
    {
      path: "listCompObligations",
      element: (
        <RouteProtector allowedUsers={["isBusiness"]}>
          <ListCompanyObligations />
        </RouteProtector>
      ),
    },
    {
      path: "listSubscriptions",
      element: (
        <RouteProtector allowedUsers={["isBusiness"]}>
          <ListSubscriptions />
        </RouteProtector>
      ),
    },
    {
      path: "newSubscription",
      element: (
        <RouteProtector allowedUsers={["isBusiness", "isChamber"]}>
          <NewSubscription />
        </RouteProtector>
      ),
    },
    {
      path: "listPayments",
      element: (
        <RouteProtector allowedUsers={["isBusiness"]}>
          <ListPayments />
        </RouteProtector>
      ),
    },
    {
      path: "listCertificatePayments",
      element: (
        <RouteProtector allowedUsers={["isBusiness", "isNonGemiUser"]}>
          <ListCertificatePayments />
        </RouteProtector>
      ),
    },
    {
      path: "listFinePayments",
      element: (
        <RouteProtector allowedUsers={["isBusiness"]}>
          <ListFinePayments />
        </RouteProtector>
      ),
    },
    {
      path: "depositSuccess",
      element: (
        <RouteProtector allowedUsers={["isBusiness", "isChamber"]}>
          <DepositSuccess />
        </RouteProtector>
      ),
    },
  ],
};